// // Define hostname
// const hostname = window && window.location && window.location.hostname ? window.location.hostname : 'localhost';
// const hostMap = {
//     "www.verdantime.com": "https://verdantime-api-gdp3ec67kq-uc.a.run.app",
//     "verdantime.com": "https://verdantime-api-gdp3ec67kq-uc.a.run.app",
//     "thinkcentre.local": "http://thinkcentre.local:3001",
//     "matthews-macbook-pro.local": "http://matthews-macbook-pro.local:3001",
//     "localhost": 'http://localhost:8081',
// }
//
// const uiBaseUrl = "";
// const apiHost = hostMap[hostname];
// export const apiBaseUrl = apiHost + "/api";
//
// // Define config object
// const config = {
//     uiBaseUrl: uiBaseUrl,
//     apiBaseUrl: apiBaseUrl,
//     apiUrl: `${apiHost}${apiBaseUrl}`,
//     socketNamespace: `${apiHost}${apiBaseUrl}`,
//     simulatedDelay: 0
// }
//
// export default config;

let apiLocation = "/api"
if (process.env.NODE_ENV === 'development') apiLocation = "http://localhost:2001/api"

const config = {
    uiBaseUrl: "",
    apiUrl: `${apiLocation}`,
    socketNamespace: `${apiLocation}`,
    simulatedDelay: 0
}

export default config;
